import React, { ReactNode } from 'react'
import { connect, DispatchProp } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { AnyAction } from 'redux'
import { Button, Page, ValidatedInput } from '../../../components'
import { isCodiceValid, isDniValid, isEmailValid, isTextValid } from '../../../helpers'
import { images } from '../../../images'
import literalsService from '../../../services/literals-service'
import { saveUserInfoAction, setNotificationAction, setUserInfoDNIAction, setUserInfoEmailAction, setUserInfoLastNameAction, setUserInfoNameAction } from '../../../store/actions'
import { IStoreState, IUserInfoState } from '../../../store/states'
import StyledArticle from './styles'
import { appsStyleSelected } from '../../../helpers/app'
import { AuthenticatedRoutable } from '../../../models'

interface IProps extends IUserInfoState, DispatchProp<AnyAction>, RouteComponentProps {}

class UserInfo extends AuthenticatedRoutable<IProps> {

  public render(): ReactNode {

    const { firstName, lastName, email, dni } = this.props
    const showDNI = process.env.REACT_APP_SHOW_DNI === 'true'

    return (
      <Page>
        <Page className={ `authenticated ${appsStyleSelected?.style}` }>
          <StyledArticle>
            <img src={ images['goBack'] } className='backButton' onClick={ this.handleGoBack } />
            <form onSubmit={ e => e.preventDefault() }>
              <section>
                <h3>{ literalsService.get('personalInfo', true) }</h3>
                <ValidatedInput
                  name="firstName"
                  label={ literalsService.get('name', true) }
                  value={ firstName }
                  onChange={ this.onFirstNameChange }
                  error={ !isTextValid(firstName) }
                />
                <ValidatedInput
                  name="lastName"
                  label={ literalsService.get('lastName', true) }
                  value={ lastName }
                  onChange={ this.onLastNameChange }
                  error={ !isTextValid(lastName) }
                />
                { showDNI ?
                  <ValidatedInput
                    name="dni"
                    label={ literalsService.get('dni', true) }
                    value={ dni }
                    error={ !(isDniValid(dni) || isCodiceValid(dni)) }
                    onChange={ this.onDNIChange }
                    isReadonly
                  />
                : null }
                <h3>{ literalsService.get('userInfo', true) }</h3>
                <ValidatedInput
                  name="email"
                  label={ literalsService.get('email', true) }
                  value={ email }
                  error={ !isEmailValid(email) }
                  onChange={ this.onEmailChange }
                  isReadonly
                />
              </section>
              <Button
                title={ literalsService.get('save', true) }
                onPress={ this.save }
                className={ 'saveButton' }
                filled
                upper
              />
            </form>
          </StyledArticle>
        </Page>
      </Page>
    )
  }

  componentDidMount() {
    super.componentDidMount()
  }

  private handleGoBack = (): void => {
    history.back()
  }

  public save = (): void => {
    const { dispatch } = this.props
    dispatch(saveUserInfoAction())
    dispatch(setNotificationAction({
      label: literalsService.get('dataSaved', true),
      isError: false
    }))
    this.handleGoBack()
  }

  private onFirstNameChange = (name: string) => {
    this.props.dispatch(setUserInfoNameAction(name))
  }

  private onLastNameChange = (lastName: string) => {
    this.props.dispatch(setUserInfoLastNameAction(lastName))
  }

  private onDNIChange = (dni: string) => {
    this.props.dispatch(setUserInfoDNIAction(dni))
  }

  private onEmailChange = (email: string) => {
    this.props.dispatch(setUserInfoEmailAction(email))
  }

  private saveUserInfo = () => {
    this.props.dispatch(saveUserInfoAction())
  }
}

const mapStateToProps = ({ userInfo }: IStoreState) => ({
  ...userInfo
})

export default connect(mapStateToProps)(UserInfo)
